import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAccessToken } from "api/client";

/**
 * Minimal route guard (Phase 4): no token → login (remembering the intended
 * page so login redirects back there). Backend remains authoritative for
 * authorization; this only keeps broken authenticated screens from rendering
 * after a session expires.
 */
export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!getAccessToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}